// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,

    /* Production Setttings */
     apiUrl:'https://api.argic.org/',  //REST SERVER
     localUrl:'https://www.argic.org/',
     apiWizardUrl:'https://www.argic.org/', //OLD MVC SERVER

    /* Dev settings */
    //apiUrl: "http://localhost:49888/",
    //localUrl: "http://localhost:49888/",
    //apiWizardUrl: "http://localhost:49888/",

    assetsInfo: "/assets/docs/information/",
};
